import { Navigate } from 'react-router-dom';

import { Spinner } from '@/components/generic';
import { useAuth } from '@/contexts';
import { getDefaultPrivateRoute } from '@/helpers';

type PublicOnlyRouteProps = {
  children: JSX.Element;
};

export const PublicOnlyRoute = ({ children }: PublicOnlyRouteProps) => {
  const { user, currentUserData, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Spinner />
      </div>
    );
  }

  if (user) {
    return <Navigate to={getDefaultPrivateRoute(currentUserData)} replace />;
  }

  return children;
};
